import { Link } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";
import { cn } from "@/lib/utils";

export const Breadcrumbs = ({ items, light = false }) => (
  <nav aria-label="Brotkrumen" data-testid="breadcrumbs" className="mb-6">
    <ol className={cn("flex flex-wrap items-center gap-1.5 text-sm", light ? "text-white/80" : "text-brand-ink/70")}>
      <li>
        <Link to="/" className={cn("inline-flex items-center gap-1 hover:underline", light && "hover:text-white")} data-testid="breadcrumb-home">
          <Home className="h-3.5 w-3.5" /> Startseite
        </Link>
      </li>
      {items.map((item, i) => (
        <li key={item.to} className="inline-flex items-center gap-1.5">
          <ChevronRight className="h-3.5 w-3.5 opacity-60" />
          {i === items.length - 1 ? (
            <span aria-current="page" className={cn("font-semibold", light ? "text-white" : "text-brand-anthracite")}>{item.label}</span>
          ) : (
            <Link to={item.to} className="hover:underline">{item.label}</Link>
          )}
        </li>
      ))}
    </ol>
  </nav>
);
